import { z } from 'zod/v4';
export const variableValueSchema = z.union([z.string(), z.array(z.string()), z.null()]);
